import type { ToggleUserStatusDialogProps } from "./types-toggle-user-status-dialog";
import { useToggleUserStatusDialog } from "./use-toggle-user-status-dialog";
import { ToggleUserStatusDialogView } from "./view-toggle-user-status-dialog";

/** Modal de confirmação "Desativar usuário" / "Ativar usuário" (HU 723). */
export function ToggleUserStatusDialog(props: ToggleUserStatusDialogProps) {
  const vm = useToggleUserStatusDialog(props);

  return <ToggleUserStatusDialogView {...vm} />;
}

export type * from "./types-toggle-user-status-dialog";
